import React from 'react';
import styles from './Bussiness.module.css';

const Business = ({ lang }) => {
  const data = {
    EN: {
      title: "Business Stream",
      news: [
        "Gold prices reach historic peak", "Major merger in Tech Industry", "New tax laws for 2026", "Global supply chain recovery", "Why investors are buying AI stocks", "Retail market shifting online"
      ]
    },
    UR: {
      title: "کاروباری اسٹریم",
      news: [
        "سونے کی قیمتیں تاریخی بلندی پر", "ٹیک انڈسٹری میں بڑا انضمام", "2026 کے لیے نئے ٹیکس قوانین", "عالمی سپلائی چین کی بحالی", "سرمایہ کار اے آئی اسٹاکس کیوں خرید رہے ہیں", "پرچون مارکیٹ کا آن لائن رجحان"
      ]
    }
  }[lang];

  return (
    <section className={styles.businessSection}>
      <h2 className={styles.sectionHeader}>{data.title}</h2>
      
      <div className={styles.layoutGrid}>
        {/* Featured Big Story */}
        <div className={styles.featuredCard}>
          <img src="https://picsum.photos/600/400?random=5000" alt="featured" />
          <div className={styles.featuredContent}>
            <h3>Global Business Outlook 2026: The Year of Transition</h3>
            <p>An in-depth report on how the global economy is reshaping its foundations for a digital-first future.</p>
          </div>
        </div>

        {/* Dense News List */}
        <div className={styles.newsList}>
          {data.news.map((item, i) => (
            <div key={i} className={styles.listItem}>
              <img src={`https://picsum.photos/200/200?random=${i + 6000}`} alt="news" />
              <div>
                <span style={{fontSize: '0.7rem', color: '#e74c3c'}}>LATEST</span>
                <h4 style={{margin: '5px 0'}}>{item}</h4>
              </div>
            </div>
          ))}
        </div>
      </div>

      <button className={styles.moreBtn}>LOAD MORE ARTICLES</button>
    </section>
  );
};

export default Business;